import React from 'react'
import { View, StyleSheet, TouchableOpacity } from 'react-native'
import { useQuery } from 'convex/react'
import { api } from '@ppwr/convex/_generated/api'
import { useRouter } from 'expo-router'

import { DS } from '../../design-system'
import { useStore } from '../../models'
import { formatChipsNumber } from '@/components/GameAssets/Player/PlayerBox'
import { GAME_CONSTANTS } from '@ppwr/convex/shared/constants'
import { Wrapper } from './PlayerStats'
import { formatPlayDate } from '../../utils/dateFormatter'

interface StatItemProps {
  value: string
  label: string
}

const StatItem: React.FC<StatItemProps> = ({ value, label }) => (
  <View style={styles.statItem}>
    <DS.Text variant="Heading 5/Medium">{value}</DS.Text>
    <DS.Text variant="Caption/Regular" color="Brand/Dark Grey">
      {label}
    </DS.Text>
  </View>
)

export const Daily10History: React.FC = () => {
  const { user } = useStore().session
  const userId = user?.auth0Id || 'guest'
  const todayDate = formatPlayDate()
  const router = useRouter()

  const history = useQuery(api.games.queries.getDaily10History, { userId, todayDate })

  if (!history) return null

  const { DEFAULT_GAME_NAME_PERSONALIZED } = GAME_CONSTANTS.DAILY10_CONSTANTS

  return (
    <TouchableOpacity onPress={() => router.navigate('/daily10/log')} activeOpacity={0.7}>
      <Wrapper style={styles.wrapper}>
        <View style={styles.content}>
          <DS.Text variant="Caption/Bold" uppercase>
            {DEFAULT_GAME_NAME_PERSONALIZED}
          </DS.Text>
          <View style={styles.statsRow}>
            <StatItem value={String(history.currentStreak)} label="Current Streak" />
            <StatItem value={String(history.longestStreak)} label="Longest Streak" />
            <StatItem value={formatChipsNumber(history.bestChips)} label="Best Score" />
          </View>
        </View>
        <DS.Icon name="Arrow---right" size={20} color="Global/Black" />
      </Wrapper>
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  wrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: DS.spacing[16],
    gap: DS.spacing[12]
  },
  content: {
    flex: 1,
    gap: DS.spacing[12]
  },
  statsRow: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center'
  },
  statItem: {
    alignItems: 'center',
    gap: DS.spacing[4]
  }
})
